<template>
  <div class="container">
    <div class="section">
      <title-bar title="Webhooks" class="title is-4 mb-1"/>
      <p class="subtitle is-7">Administra los endpoints que recibirán notificaciones automáticas sobre eventos importantes en tu cuenta.</p>
      <div class="columns is-multiline">
        <div class="column is-12">
          <nav slot="content-actions">
            <div class="buttons is-vcentered is-pulled-right">
              <button
              class="button btn-is-blue cutom-button" @click="isModalOpen = true"
              >Agregar webhook</button>
            </div>
          </nav>
        </div>
        <div class="column is-12">
          <WebhooksList
            :webhooks="webhooks"
            :role="role"
            :pagination="pagination"
            :getWebhooks="getWebhooksList"
            :isLoading="isLoading"
            :probarWebhook="probarWebhook"
          />
        </div>
      </div>
    </div>
    <ModalAddWebhook
      v-if="isModalOpen"
      :showModal="isModalOpen"
      :close="cancel"
    />
    <ModalTestWebhook
      :showModalTest="showModalTest"
      :closeModalTest="closeModalTest"
      :eventName="eventName"
      :webhookUrl="webhookUrl"
      :webhookHeader="webhookHeader"
      :statusCode="statusCode"
      :respBody="respBody"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
import ModalAddWebhook from '../../components/Webhook/ModalAddWebhook.vue'
export default {
  name: 'Webhooks',
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue'),
    WebhooksList: () => import('@/components/Webhook/WebhookList.vue'),
    ModalAddWebhook,
    ModalTestWebhook: () => import('@/components/Webhook/ModalTestWebhook.vue')
  },
  mixins: [mixins],
  data () {
    return {
      loading: true,
      isLoading: false,
      loadingTest: false,
      isSent: false,
      webhooks: [],
      isModalOpen: false,
      showModalTest: false,
      pagination: {},
      headers: '',
      url: '',
      descriptions: '',
      eventId: '',
      role: {},
      statusCode: null,
      respBody: null,
      eventName: '',
      webhookUrl: '',
      webhookHeader: '',
      error: ''
    }
  },
  methods: {
    ...mapActions(['getWebhooks', 'profileMe', 'testWebhook']),
    getWebhooksList (page) {
      this.getWebhooks({ pageNumber: page, perPage: 10 })
        .then(({ webhookPages, pagination }) => {
          this.webhooks = webhookPages
          this.pagination = pagination
        })
    },
    async probarWebhook (webhook) {
      this.loadingTest = true
      this.showModalTest = true
      const test = await this.testWebhook({ webhookId: webhook.id, eventId: webhook.event.id })
      if (test) {
        this.statusCode = test.statusCode
        this.respBody = test.responseBody
        this.eventName = webhook.event.name
        this.webhookUrl = webhook.url
        this.webhookHeader = webhook.headers
      } else {
        this.loadingTest = false
        this.showModalTest = false
      }
      this.loadingTest = false
    },
    cancel () {
      this.isModalOpen = false
    },
    closeModalTest () {
      this.showModalTest = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany.financialCompany
    })
  },
  mounted () {
    const data = {
      pageNumber: 0,
      perPage: 10
    }
    this.isLoading = true
    this.getWebhooks(data)
      .then(({ webhookPages, pagination }) => {
        this.webhooks = webhookPages
        this.pagination = pagination
        this.isLoading = false
      })
  }

}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.cutom-button {
  padding: 1.2rem !important;
}
.json-block {
  border-radius: 6px;
  padding: 1rem;
  font-size: 14px;
  white-space: pre;
  overflow-x: auto;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}
</style>
